import React from 'react'
import Image from 'marketing-site/src/components/common/NextImageWrapper'
import { IProps } from './index'
import { mq } from 'marketing-site/src/library/utils'
import { Text } from 'marketing-site/src/library/elements/Text'
import { TextLink } from 'marketing-site/src/mvp/library/elements/TextLink'

export const NameplateCard = ({ image, name, jobTitle, subhead, bioLink }: IProps) => {
  const imageSizes = {
    tablet: { width: 392, height: 261 },
  }
  return (
    <div className="nameplate-card">
      <div className="nameplate-card__image">
        <Image
          src={image.url}
          width={335}
          height={223}
          layout={'responsive'}
          alt={image.altText}
          quality={100}
          sizes={`(${mq.tablet}) ${imageSizes.tablet.width}px, ${imageSizes.tablet.height}px`}
        />
      </div>
      <div className="nameplate-card__name">
        <Text size="heading-4">{name}</Text>
      </div>
      <div className="nameplate-card__job-title">
        <Text size="subhead-sm">{jobTitle}</Text>
      </div>
      {subhead && (
        <div className="nameplate-card__subhead">
          <Text size="body">{subhead}</Text>
        </div>
      )}
      {bioLink && (
        <div className="nameplate-card__bio-link">
          <TextLink {...bioLink} />
        </div>
      )}
      <style jsx>{`
        .nameplate-card {
          max-width: 21rem;
          display: flex;
          flex-direction: column;
          margin: 0 auto;

          &__image {
            border-radius: 1rem;
            overflow: hidden;
            transition: transform 0.5s;
            &:hover {
              transform: ${bioLink && 'translateY(-4px)'};
            }
          }

          &__name {
            margin: 1.5rem 0.5rem 0 0.5rem;
          }

          &__job-title {
            margin: 0.25rem 0.5rem 0 0.5rem;
          }

          &__subhead {
            margin: 1rem 0.5rem 0 0.5rem;
          }

          &__bio-link {
            margin: 0.5rem 0.5rem 0 0.5rem;
          }
        }

        @media (${mq.tablet}) {
          .nameplate-card {
            max-width: 24.5rem;
            &__image {
              border-radius: 1.5rem;
            }

            &__name {
              margin: 2rem 0.5rem 0 0.5rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
